/** 변화탐지 결과 레이어 카테고리 — 추가 / 제거 / 변경 */
export type CdDiffCategory = 'add' | 'rem' | 'chg'
/** 카테고리별 지도 표시 여부 */
export type CdDiffVisible = Record<CdDiffCategory, boolean>

export type CdProjectStatus = 'ACTIVE' | 'DELETING'
export type CdDatasetType = 'POINT_CLOUD' | 'MESH'
export type CdVoxelStatus = 'NONE' | 'QUEUED' | 'RUNNING' | 'SUCCEEDED' | 'FAILED' | 'CANCELLED'
export type CdDiffType = 'A_B' | 'TIME_SERIES'
export type CdDiffStatus = 'QUEUED' | 'RUNNING' | 'SUCCEEDED' | 'FAILED' | 'PARTIAL_FAILED' | 'CANCELLED'
export type CdDiffItemStatus = 'QUEUED' | 'RUNNING' | 'SUCCEEDED' | 'FAILED' | 'CANCELLED'

export interface CdProject {
  id: number
  name: string
  description: string | null
  centerLon: number | null
  centerLat: number | null
  cameraHeight: number | null
  status: CdProjectStatus
  observationCount: number
  hasRegionGpkg: boolean
  regionGpkgFileName: string | null
  createdAt: string
  updatedAt: string | null
}

export interface CdObservation {
  id: number
  projectId: number
  meshDataId: number
  meshDataName: string
  observedAt: string
  label: string | null
  datasetType: CdDatasetType
  voxelStatus: CdVoxelStatus
  originalTilesetUrl: string | null
  voxelTilesetUrl: string | null
  errorMessage: string | null
  createdAt: string
}

export interface CdDiffItem {
  id: number
  diffId: number
  sourceObservationId: number
  targetObservationId: number
  sourceObservedAt: string
  targetObservedAt: string
  status: CdDiffItemStatus
  resultTilesetUrl: string | null
  addedVolume: number | null
  removedVolume: number | null
  changedVolume: number | null
  startedAt: string | null
  finishedAt: string | null
}

export interface CdDiff {
  id: number
  projectId: number
  name: string
  type: CdDiffType
  status: CdDiffStatus
  maxLevel: number | null
  visualize: boolean | null
  diffNeighborMode: number | null
  minDiffFilterLevel: number | null
  minDiffNeighbors: number | null
  diffNeighborIterations: number | null
  minDiffClusterSize: number | null
  massSummary: boolean | null
  cubeDataType: string | null
  recursive: boolean | null
  areaWkt: string | null
  errorMessage: string | null
  items: CdDiffItem[]
  createdAt: string
}

export interface CdProjectPayload {
  name: string
  description?: string | null
  centerLon?: number | null
  centerLat?: number | null
  cameraHeight?: number | null
}

export interface CdObservationPayload {
  meshDataId: number
  observedAt: string
  label?: string | null
  datasetType: CdDatasetType
}

export const CD_VOXEL_STATUS_LABEL: Record<CdVoxelStatus, string> = {
  NONE: '대기 전',
  QUEUED: '대기 중',
  RUNNING: 'voxel 생성 중',
  SUCCEEDED: '완료',
  FAILED: '실패',
  CANCELLED: '취소됨',
}

export const CD_DIFF_STATUS_LABEL: Record<CdDiffStatus, string> = {
  QUEUED: '대기 중',
  RUNNING: '분석 중',
  SUCCEEDED: '완료',
  FAILED: '실패',
  PARTIAL_FAILED: '일부 실패',
  CANCELLED: '취소됨',
}

export type CdReportFormat = 'PDF' | 'HWPX'
export type CdReportStatus = 'QUEUED' | 'RUNNING' | 'SUCCEEDED' | 'FAILED'

export interface CdReport {
  id: number
  diffId: number
  format: CdReportFormat
  status: CdReportStatus
  fileName: string
  errorMessage: string | null
  createdAt: string
}

export const CD_REPORT_STATUS_LABEL: Record<CdReportStatus, string> = {
  QUEUED: '대기 중',
  RUNNING: '생성 중',
  SUCCEEDED: '완료',
  FAILED: '실패',
}
